<div
  [ngStyle]="{
    display: (scheduleService.schedulesWithoutOverlap$ | async)?.length ? 'block' : 'none'
  }"
>
  <div class="timemanager-content flex flex-row" [class.is-scrolled]="isScrolled">
    <div class="timeline-container flex-[50px] max-w-[50px]">
      <app-timeline></app-timeline>
    </div>
    <div class="schedules-container flex-1" #schedulesContainerRef>
      <div class="timemanager-header flex flex-row gap-[4px]">
        <div class="flex flex-row gap-[4px] flex-1">
          <div *ngFor="let day of getDays()" class="day flex-[1_0_90px] min-w-[90px]">
            {{ day }}
          </div>
        </div>
      </div>
      <app-schedules>
        <app-schedule
          *ngFor="let schedule of scheduleService.schedulesWithoutOverlap$ | async; let idx = index"
          id="{{ getId(idx) }}"
          class="flex-[1_0_90px] min-w-[90px]"
        >
          <app-program
            *ngFor="let program of schedule"
            [attr.data-at-program-mode]="program.mode"
            [attr.data-at-program-start]="program.start"
            [scheduleId]="idx"
            [duration]="program.duration"
            [program]="program.mode"
            [start]="program.start"
          ></app-program>
        </app-schedule>
      </app-schedules>
    </div>
  </div>
</div>
